export const DEFAULT_LOCALE: string = 'de'
